export enum TIME_REPORT_STATUS {
	ATTESTED_BY_ADMIN = "ATTESTED_BY_ADMIN",
	ATTESTED_BY_CUSTOMER = "ATTESTED_BY_CUSTOMER",
	DECLINED_BY_CUSTOMER = "DECLINED_BY_CUSTOMER",
	SILENT_ATTESTED = "SILENT_ATTESTED",
	INVOICED = "INVOICED",
	NOT_WORKED = "NOT_WORKED",
	PENDING = "PENDING",
	RESOLVED_DECLINE_BY_ADMIN = "RESOLVED_DECLINE_BY_ADMIN",
	WORKED = "WORKED",
}

export type STATUS_ICON_TYPE = "DONE" | "PENDING" | "DENIED" | "RESOLVED";
